import ComingSoon from 'components/UnderDevelopment/comingSoon'
import React from 'react'
import FooterTailwind from 'TailwindcssComponents/Footer'
import TailwindLayout from 'TailwindcssComponents/TailwindLayout'
import TopBar from 'TailwindcssComponents/TopBar'

export default function FeedBacks() {
    return (
        <TailwindLayout>
            <TopBar />
            <div>
            <ComingSoon />
            </div>
            <FooterTailwind/>
        </TailwindLayout>
    )
}